/* eslint-disable camelcase */
import React from 'react';
import { Button, Card, CardBody, CardFooter } from 'reactstrap';
import { IoIosArrowForward } from 'react-icons/io';
import ProfileNameCard from 'components/ProfileNameCard';
import ActionDropdown from 'components/ActionDropdown';
import { modifiedUnderScore } from 'utils/constants';

const StaffCard = ({
  firstName,
  profile,
  lastName,
  email,
  callingCode,
  phone,
  loginEnabled,
  keyValue,
  roles,
  handleViewDetail,
  handleAddEditRecord,
  handleDelete,
}) => {
  return (
    <Card
      className="border-0 mb-3 shadow-none text-center staff-card position-relative"
      key={keyValue}
    >
      <ActionDropdown
        handleDelete={handleDelete}
        handleAddEditRecord={handleAddEditRecord}
        keyValue={keyValue}
        loginEnabled={loginEnabled}
        hideLoginToggle={roles?.some(
          (role) => role?.name?.toUpperCase() === 'SUPER_ADMIN',
        )}
      />
      <CardBody className="pb-2">
        <ProfileNameCard
          wrapperClass="mx-auto mb-2"
          profile={profile}
          fname={firstName && firstName.charAt(0)}
          lname={lastName && lastName.charAt(0)}
        />
        <h4 className="f-14 mb-2 text-capitalize">{`${firstName} ${lastName}`}</h4>
        <h4 className="f-12 mb-2 fw-semibold text-orange text-uppercase ">
          {roles && roles.length
            ? roles?.map((role) => modifiedUnderScore(role.name)).join(', ')
            : 'Roles not assigned yet.'}
          {/* {roles?.[0]?.name ? roles[0]?.name : 'Roles not assigned yet.'} */}
        </h4>
        <h4 className="f-12 mb-2 fw-medium">
          {email || 'Email not available'}
        </h4>
        {/* <h5 className="f-12 mb-2 fw-medium">
          {addresses?.[0]?.length
            ? `${addresses[0] ? addresses[0]?.city?.cityName : '-'}, ${
                addresses[0] ? addresses[0]?.state?.stateName : '-'
              }`
            : 'Address not available'}
        </h5> */}
        <h4 className="f-12 mb-2 fw-medium">
          {phone
            ? `${callingCode?.callingCode}-${phone}`
            : 'Phone number not available'}
        </h4>
      </CardBody>
      <CardFooter className="px-2 bg-white">
        <Button
          className="d-flex text-decoration-none f-12 p-0 px-1 w-100 align-items-center justify-content-between"
          color="link"
          onClick={handleViewDetail}
        >
          View Details <IoIosArrowForward />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default StaffCard;
